// Copyright 2025. WebPros International GmbH. All rights reserved.

export enum ACCOUNT_TABS {
    SETTINGS = '#settings',
    API_TOKENS = '#api-tokens',
    SSH_KEYS = '#ssh-keys',
    TWO_FACTOR_AUTH = '#two-factor-auth',
}
